'use client';

import React, { useEffect } from 'react';
import { scheduleFreestarPubfig } from '@benzinga/ads-utils';

export const FreestarPubfig: React.FC = () => {
  useEffect(() => scheduleFreestarPubfig(), []);
  return null;
};
